var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-container", { attrs: { fluid: "" } }, [
    _c("div", [
      _c("div", { staticClass: "holder" }, [
        _c(
          "h2",
          { attrs: { id: "page-header" } },
          [
            _c("router-link", { attrs: { to: "/parkaccessibility" } }, [
              _vm._v(
                " Filter Park Amenities & Accessible Features to Find a Park that Fits your Needs"
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { attrs: { id: "blurb" } }, [
          _c("p", [
            _vm._v(
              "\n                Everyone, everywhere, every day: access for all! That's the Arlington way. We are not only striving to meet "
            ),
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href:
                    "https://www.access-board.gov/guidelines-and-standards/buildings-and-sites/about-the-ada-standards#:~:text=The%20ADA%20Standards%20establish%20design,state%20and%20local%20government%20facilities."
                }
              },
              [_vm._v("ADA Standards")]
            ),
            _vm._v(
              ", we want to do more. Use this form to filter the amenities and accessible features in our parks to find the ones that meet your needs. \n                "
            ),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c("strong", [_vm._v("How to use: ")]),
            _c("br"),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "You can filter by any combination of amenities or accessible features by clicking on the plus icon to expand the options. Select as many as you would like by checking the box next to each option. The results will update automatically based on each amenity or accessible feature you select/deselect. "
              )
            ]),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c("strong", [_vm._v("Viewing Results: ")]),
            _c("br"),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "You can view your filter results in map or list form. Click on the Map or List text above the map. To view the details of a park, click on the blue location icon(s) on the map.  "
              )
            ]),
            _c("br"),
            _c("br"),
            _vm._v("\n                To request a correction, fill out this "),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://parks.arlingtonva.us/park-accessibility-correction-request/",
                  target: "_blank"
                }
              },
              [_vm._v("form")]
            ),
            _vm._v(".\n            ")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layer-page" }, [
        _c("div", { staticClass: "widget one-third filter-pane" }, [
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isMobile || _vm.mobileMenu === false,
                  expression: "isMobile || mobileMenu === false"
                }
              ],
              staticClass: "filter-header",
              attrs: {
                type: "button",
                id: "mobile-menu",
                "aria-expanded": _vm.mobileMenu ? "true" : "false",
                "aria-controls": "filters-and-settings"
              },
              on: {
                click: function($event) {
                  _vm.mobileMenu = !_vm.mobileMenu
                }
              }
            },
            [
              _vm._v(
                "\n                  Filters and Location\n                  "
              ),
              _c(
                "svg",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.mobileMenu,
                      expression: "!mobileMenu"
                    }
                  ],
                  staticClass: "icon",
                  staticStyle: { float: "right" },
                  attrs: { "aria-hidden": "true", focusable: "false" }
                },
                [_c("use", { attrs: { "xlink:href": "#icon-plus" } })]
              ),
              _vm._v(" "),
              _c(
                "svg",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.mobileMenu,
                      expression: "mobileMenu"
                    }
                  ],
                  staticClass: "icon",
                  staticStyle: { float: "right" },
                  attrs: { "aria-hidden": "true", focusable: "false" }
                },
                [_c("use", { attrs: { "xlink:href": "#icon-minus" } })]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isMobile || _vm.mobileMenu,
                  expression: "!isMobile || mobileMenu"
                }
              ],
              attrs: { id: "filters-and-settings" }
            },
            [
              _c("div", { staticClass: "filter-container" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isMobile,
                        expression: "!isMobile"
                      }
                    ],
                    staticClass: "filter-header",
                    attrs: {
                      type: "button",
                      "aria-expanded": _vm.amenityFilter ? "true" : "false",
                      "aria-controls": "parks-amenity-filter-list"
                    },
                    on: {
                      click: function($event) {
                        _vm.amenityFilter = !_vm.amenityFilter
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v("Amenity\n                              "),
                      _c(
                        "svg",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.amenityFilter,
                              expression: "amenityFilter"
                            }
                          ],
                          staticClass: "icon",
                          staticStyle: { float: "right" },
                          attrs: { "aria-hidden": "true", focusable: "false" }
                        },
                        [_c("use", { attrs: { "xlink:href": "#icon-minus" } })]
                      ),
                      _vm._v(" "),
                      _c(
                        "svg",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.amenityFilter,
                              expression: "!amenityFilter"
                            }
                          ],
                          staticClass: "icon",
                          staticStyle: { float: "right" },
                          attrs: { "aria-hidden": "true", focusable: "false" }
                        },
                        [_c("use", { attrs: { "xlink:href": "#icon-plus" } })]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticStyle: { clear: "both", display: "block" }
                      })
                    ])
                  ]
                ),
                !_vm.amenityFilter ? _c("br") : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.amenityFilter || _vm.mobileMenu,
                        expression: "amenityFilter || mobileMenu"
                      }
                    ],
                    staticClass: "filterList",
                    attrs: { id: "parks-amenity-filter-list" }
                  },
                  [
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.typeSelected,
                              expression: "typeSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "parking",
                            checked: Array.isArray(_vm.typeSelected)
                              ? _vm._i(_vm.typeSelected, "parking") > -1
                              : _vm.typeSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.typeSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "parking",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.typeSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.typeSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.typeSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" Parking")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.typeSelected,
                              expression: "typeSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "restroom",
                            checked: Array.isArray(_vm.typeSelected)
                              ? _vm._i(_vm.typeSelected, "restroom") > -1
                              : _vm.typeSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.typeSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "restroom",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.typeSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.typeSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.typeSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" Restroom")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.typeSelected,
                              expression: "typeSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "seating",
                            checked: Array.isArray(_vm.typeSelected)
                              ? _vm._i(_vm.typeSelected, "seating") > -1
                              : _vm.typeSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.typeSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "seating",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.typeSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.typeSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.typeSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" Seating")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.typeSelected,
                              expression: "typeSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "playarea",
                            checked: Array.isArray(_vm.typeSelected)
                              ? _vm._i(_vm.typeSelected, "playarea") > -1
                              : _vm.typeSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.typeSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "playarea",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.typeSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.typeSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.typeSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" Play Area")
                        ])
                      ])
                    ]),
                    _c("br")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isMobile,
                        expression: "!isMobile"
                      }
                    ],
                    staticClass: "filter-header",
                    attrs: {
                      type: "button",
                      "aria-expanded": _vm.accessibilityFilter
                        ? "true"
                        : "false",
                      "aria-controls": "parks-accessibility-filter-list"
                    },
                    on: {
                      click: function($event) {
                        _vm.accessibilityFilter = !_vm.accessibilityFilter
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "Accessible Features\n                              "
                      ),
                      _c(
                        "svg",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.accessibilityFilter,
                              expression: "accessibilityFilter"
                            }
                          ],
                          staticClass: "icon",
                          staticStyle: { float: "right" },
                          attrs: { "aria-hidden": "true", focusable: "false" }
                        },
                        [_c("use", { attrs: { "xlink:href": "#icon-minus" } })]
                      ),
                      _vm._v(" "),
                      _c(
                        "svg",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.accessibilityFilter,
                              expression: "!accessibilityFilter"
                            }
                          ],
                          staticClass: "icon",
                          staticStyle: { float: "right" },
                          attrs: { "aria-hidden": "true", focusable: "false" }
                        },
                        [_c("use", { attrs: { "xlink:href": "#icon-plus" } })]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticStyle: { clear: "both", display: "block" }
                      })
                    ])
                  ]
                ),
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.accessibilityFilter || _vm.mobileMenu,
                        expression: "accessibilityFilter || mobileMenu"
                      }
                    ],
                    staticClass: "filterList",
                    attrs: { id: "parks-accessibility-filter-list" }
                  },
                  [
                    _c(
                      "div",
                      [
                        _c("label", { attrs: { for: "parks-select-trails" } }, [
                          _vm._v("Trails")
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm12: "", "d-flex": "" } },
                          [
                            _c("v-select", {
                              attrs: {
                                id: "parks-select-trails",
                                items: _vm.trailsFilter,
                                outline: "",
                                dense: true,
                                height: "20px",
                                multiple: "",
                                hint: "Select a surface"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "selection",
                                  fn: function(ref) {
                                    var item = ref.item
                                    var index = ref.index
                                    return [
                                      index === 0 && item.length > 14
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                item.substring(0, 14) + ".."
                                              ) + "   "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index === 0 && item.length <= 14
                                        ? _c("span", [
                                            _vm._v(_vm._s(item) + "   ")
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index === 1
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "grey--text caption"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    (+" +
                                                  _vm._s(
                                                    _vm.trailsFilterSelected
                                                      .length - 1
                                                  ) +
                                                  " others)\n                                  "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.trailsFilterSelected,
                                callback: function($$v) {
                                  _vm.trailsFilterSelected = $$v
                                },
                                expression: "trailsFilterSelected"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("label", { attrs: { for: "parks-select-fenced" } }, [
                          _vm._v("Fenced In")
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm12: "", "d-flex": "" } },
                          [
                            _c("v-select", {
                              attrs: {
                                id: "parks-select-fenced",
                                items: _vm.playAreaFilter,
                                outline: "",
                                dense: true,
                                height: "20",
                                multiple: ""
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "selection",
                                  fn: function(ref) {
                                    var item = ref.item
                                    var index = ref.index
                                    return [
                                      index === 0 && item.length > 14
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                item.substring(0, 14) + ".."
                                              ) + "   "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index === 0 && item.length <= 14
                                        ? _c("span", [
                                            _vm._v(_vm._s(item) + "   ")
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index === 1
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "grey--text caption"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    (+" +
                                                  _vm._s(
                                                    _vm.playAreaFilterSelected
                                                      .length - 1
                                                  ) +
                                                  " others)\n                                  "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.playAreaFilterSelected,
                                callback: function($$v) {
                                  _vm.playAreaFilterSelected = $$v
                                },
                                expression: "playAreaFilterSelected"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "label",
                          { attrs: { for: "parks-select-surface" } },
                          [_vm._v("Play Surface Material")]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm12: "", "d-flex": "" } },
                          [
                            _c("v-select", {
                              attrs: {
                                id: "parks-select-surface",
                                items: _vm.playGroundCoverFilter,
                                outline: "",
                                dense: true,
                                height: "20",
                                multiple: ""
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "selection",
                                  fn: function(ref) {
                                    var item = ref.item
                                    var index = ref.index
                                    return [
                                      index === 0 && item.length > 14
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                item.substring(0, 14) + ".."
                                              ) + "   "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index === 0 && item.length <= 14
                                        ? _c("span", [
                                            _vm._v(_vm._s(item) + "   ")
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index === 1
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "grey--text caption"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    (+" +
                                                  _vm._s(
                                                    _vm
                                                      .playGroundCoverFilterSelected
                                                      .length - 1
                                                  ) +
                                                  " others)\n                                  "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.playGroundCoverFilterSelected,
                                callback: function($$v) {
                                  _vm.playGroundCoverFilterSelected = $$v
                                },
                                expression: "playGroundCoverFilterSelected"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("label", { attrs: { for: "parks-select-sun" } }, [
                          _vm._v("Access to Sun Cover")
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm12: "", "d-flex": "" } },
                          [
                            _c("v-select", {
                              attrs: {
                                id: "parks-select-sun",
                                items: _vm.sunCoverFilter,
                                outline: "",
                                dense: true,
                                height: "20",
                                multiple: ""
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "selection",
                                  fn: function(ref) {
                                    var item = ref.item
                                    var index = ref.index
                                    return [
                                      index === 0 && item.length > 14
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                item.substring(0, 14) + ".."
                                              ) + "   "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index === 0 && item.length <= 14
                                        ? _c("span", [
                                            _vm._v(_vm._s(item) + "   ")
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index === 1
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "grey--text caption"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    (+" +
                                                  _vm._s(
                                                    _vm.sunCoverFilterSelected
                                                      .length - 1
                                                  ) +
                                                  " others)\n                                  "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.sunCoverFilterSelected,
                                callback: function($$v) {
                                  _vm.sunCoverFilterSelected = $$v
                                },
                                expression: "sunCoverFilterSelected"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("label", { attrs: { for: "parks-select-access" } }, [
                          _vm._v("Play/Park Access")
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm12: "", "d-flex": "" } },
                          [
                            _c("v-select", {
                              attrs: {
                                id: "parks-select-access",
                                items: _vm.parkAccessFilter,
                                outline: "",
                                dense: true,
                                height: "20",
                                multiple: ""
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "selection",
                                  fn: function(ref) {
                                    var item = ref.item
                                    var index = ref.index
                                    return [
                                      index === 0 && item.length > 14
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                item.substring(0, 14) + ".."
                                              ) + "   "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index === 0 && item.length <= 14
                                        ? _c("span", [
                                            _vm._v(_vm._s(item) + "   ")
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index === 1
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "grey--text caption"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    (+" +
                                                  _vm._s(
                                                    _vm.parkAccessFilterSelected
                                                      .length - 1
                                                  ) +
                                                  " others)\n                                  "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.parkAccessFilterSelected,
                                callback: function($$v) {
                                  _vm.parkAccessFilterSelected = $$v
                                },
                                expression: "parkAccessFilterSelected"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "label",
                          { attrs: { for: "parks-select-proximity" } },
                          [_vm._v("Proximity to Roads")]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm12: "", "d-flex": "" } },
                          [
                            _c("v-select", {
                              attrs: {
                                id: "parks-select-proximity",
                                items: _vm.proximityFilter,
                                outline: "",
                                dense: true,
                                height: "20",
                                multiple: ""
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "selection",
                                  fn: function(ref) {
                                    var item = ref.item
                                    var index = ref.index
                                    return [
                                      index === 0 && item.length > 14
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                item.substring(0, 14) + ".."
                                              ) + "   "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index === 0 && item.length <= 14
                                        ? _c("span", [
                                            _vm._v(_vm._s(item) + "   ")
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index === 1
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "grey--text caption"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    (+" +
                                                  _vm._s(
                                                    _vm.proximityFilterSelected
                                                      .length - 1
                                                  ) +
                                                  " others)\n                                  "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.proximityFilterSelected,
                                callback: function($$v) {
                                  _vm.proximityFilterSelected = $$v
                                },
                                expression: "proximityFilterSelected"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("label", { attrs: { for: "parks-select-pond" } }, [
                          _vm._v("Access to Pond/Stream")
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm12: "", "d-flex": "" } },
                          [
                            _c("v-select", {
                              attrs: {
                                id: "parks-select-pond",
                                items: _vm.pondFilter,
                                outline: "",
                                dense: true,
                                height: "20",
                                multiple: ""
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "selection",
                                  fn: function(ref) {
                                    var item = ref.item
                                    var index = ref.index
                                    return [
                                      index === 0 && item.length > 14
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                item.substring(0, 14) + ".."
                                              ) + "   "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index === 0 && item.length <= 14
                                        ? _c("span", [
                                            _vm._v(_vm._s(item) + "   ")
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index === 1
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "grey--text caption"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    (+" +
                                                  _vm._s(
                                                    _vm.pondFilterSelected
                                                      .length - 1
                                                  ) +
                                                  " others)\n                                  "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.pondFilterSelected,
                                callback: function($$v) {
                                  _vm.pondFilterSelected = $$v
                                },
                                expression: "pondFilterSelected"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("h3", [_vm._v("Zoom to Location")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-container zoom-container" },
                [
                  _c("label", { attrs: { for: "addressSearch" } }, [
                    _vm._v("Address")
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("gmap-autocomplete", {
                    ref: "autocomplete",
                    attrs: {
                      id: "addressSearch",
                      placeholder: "Enter street address"
                    },
                    on: { place_changed: _vm.placeChanged }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "filter-container" }, [
                _c(
                  "button",
                  {
                    staticClass: "link filter-header",
                    on: { click: _vm.clearAll }
                  },
                  [_vm._v("Clear All")]
                )
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "widget full-map-pane toggle-window" },
          [
            _c("div", { staticStyle: { position: "relative", top: "0" } }, [
              _c(
                "div",
                {
                  staticClass: "toggle-bar",
                  attrs: { role: "group", "aria-label": "Map or list" }
                },
                [
                  _c(
                    "button",
                    {
                      class:
                        _vm.showMap === true
                          ? "toggle-link"
                          : "toggle-link active",
                      attrs: {
                        type: "button",
                        "aria-pressed": _vm.showMap === true
                      },
                      on: {
                        click: function($event) {
                          _vm.showMap = true
                        }
                      }
                    },
                    [_vm._v("Map")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      class:
                        _vm.showMap === false
                          ? "toggle-link"
                          : "toggle-link active",
                      attrs: {
                        type: "button",
                        "aria-pressed": _vm.showMap === false,
                        id: "list-link"
                      },
                      on: {
                        click: function($event) {
                          _vm.showMap = false
                        }
                      }
                    },
                    [_vm._v("List")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "gmap-map",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showMap,
                    expression: "showMap"
                  }
                ],
                attrs: {
                  center: _vm.mapCenter,
                  zoom: _vm.zoomLevel,
                  options: _vm.mapStyles,
                  id: "vue-map-container",
                  "aria-label": "Map of parks and amenities"
                }
              },
              [
                _vm._l(_vm.filteredItems, function(item) {
                  return _c("gmap-marker", {
                    key: item.name,
                    attrs: {
                      position: item,
                      icon: _vm.icon,
                      options: _vm.shapeOptions
                    },
                    on: {
                      click: function(e) {
                        return _vm.shapeClick(item, e)
                      }
                    }
                  })
                }),
                _vm._v(" "),
                _c(
                  "gmap-info-window",
                  {
                    attrs: {
                      opened: _vm.selectedInfoWindowPosition !== null,
                      position: _vm.selectedInfoWindowPosition
                    },
                    on: { closeclick: _vm.infoWindowCloseClick }
                  },
                  [
                    _c("div", { staticClass: "info-window" }, [
                      _c("h3", { staticClass: "info-window-header" }, [
                        _vm.selectedItem.Park
                          ? _c("b", {
                              domProps: {
                                innerHTML: _vm._s(_vm.selectedItem.Park)
                              }
                            })
                          : _c("b", [_vm._v("Park")])
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.selectedItem["Address"]))]),
                      _vm._v(" "),
                      _c("br"),
                      _c("br"),
                      _vm._v(" "),
                      _vm.selectedItem["Parking Access"]
                        ? _c("span", [
                            _c("b", [_vm._v("Parking Access:")]),
                            _vm._v(
                              " " + _vm._s(_vm.selectedItem["Parking Access"])
                            ),
                            _c("br")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedItem["Restroom Access"]
                        ? _c("span", [
                            _c("b", [_vm._v("Restroom Access:")]),
                            _vm._v(
                              " " + _vm._s(_vm.selectedItem["Restroom Access"])
                            ),
                            _c("br")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedItem["Park/Play Area Perimeter"]
                        ? _c("span", [
                            _c("b", [_vm._v("Park/Play Area Perimeter:")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.selectedItem["Park/Play Area Perimeter"]
                                )
                            ),
                            _c("br")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedItem["Play/Park Access"]
                        ? _c("span", [
                            _c("b", [_vm._v("Park/Play Access:")]),
                            _vm._v(
                              " " + _vm._s(_vm.selectedItem["Play/Park Access"])
                            ),
                            _c("br")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedItem["accessible playground equip."]
                        ? _c("span", [
                            _c("b", [
                              _vm._v("Accessible Playground Equipment:")
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.selectedItem[
                                    "accessible playground equip."
                                  ]
                                )
                            ),
                            _c("br")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedItem["Play/Surface Ground Cover"]
                        ? _c("span", [
                            _c("b", [_vm._v("Play Surface Material:")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.selectedItem["Play/Surface Ground Cover"]
                                )
                            ),
                            _c("br")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedItem["Access to Sun Cover"]
                        ? _c("span", [
                            _c("b", [_vm._v("Access to Sun Cover:")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.selectedItem["Access to Sun Cover"])
                            ),
                            _c("br")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedItem["Proximity to Roads"]
                        ? _c("span", [
                            _c("b", [_vm._v("Proximity to Roads:")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.selectedItem["Proximity to Roads"])
                            ),
                            _c("br")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedItem["seating"]
                        ? _c("span", [
                            _c("b", [_vm._v("Seating:")]),
                            _vm._v(" " + _vm._s(_vm.selectedItem["seating"])),
                            _c("br")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedItem["Fresh Water on Site"] &&
                      _vm.selectedItem["Fresh Water on Site"] != "n/a"
                        ? _c("span", [
                            _c("b", [_vm._v("Pond/Stream:")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.selectedItem["Fresh Water on Site"])
                            ),
                            _c("br")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedItem["Play Area on Site"] &&
                      _vm.selectedItem["Play Area on Site"] != "N/A"
                        ? _c("span", [
                            _c("b", [_vm._v("Play Area on Site:")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.selectedItem["Play Area on Site"])
                            ),
                            _c("br")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedItem["trails"] &&
                      _vm.selectedItem["trails"] != "N/A"
                        ? _c("span", [
                            _c("b", [_vm._v("Trails:")]),
                            _vm._v(" " + _vm._s(_vm.selectedItem["trails"])),
                            _c("br")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.openLink(_vm.selectedItem["URL"])
                            }
                          }
                        },
                        [_vm._v("View Full Park Details")]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.selectedCoordinates
                  ? _c("gmap-marker", {
                      attrs: { position: _vm.selectedCoordinates, radius: 24 }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.civicAssocationsSelected
                  ? _c("gmap-polygon", {
                      attrs: {
                        path: _vm.civicAssocationsSelected.paths,
                        options: _vm.locationOptions
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedCoordinates && _vm.radiusSelected
                  ? _c("GmapCircle", {
                      attrs: {
                        center: _vm.selectedCoordinates,
                        radius: _vm.radiusSelected * 1609,
                        visible: true,
                        options: {
                          fillColor: "blue",
                          fillOpacity: 0.1,
                          strokeWeight: 0.7,
                          strokeColor: "blue"
                        }
                      }
                    })
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showMap,
                    expression: "!showMap"
                  }
                ],
                staticClass: "list-pane"
              },
              _vm._l(_vm.filteredItems, function(item) {
                return _c(
                  "div",
                  { key: item.Facility, staticClass: "project" },
                  [
                    _c("div", [
                      _c("div", { staticClass: "row" }, [
                        _c("h3", { staticClass: "h3-list" }, [
                          item.Park
                            ? _c("b", {
                                domProps: { innerHTML: _vm._s(item.Park) }
                              })
                            : _c("b", [_vm._v("Park")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "no-vertical-margin" }, [
                        _c("span", [_vm._v(_vm._s(item["Address"]))]),
                        _c("br")
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("p", { staticClass: "no-vertical-margin" }, [
                        item["Parking Access"]
                          ? _c("span", [
                              _c("b", [_vm._v("Parking Access:")]),
                              _vm._v(" " + _vm._s(item["Parking Access"])),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item["Park/Play Area Perimeter"]
                          ? _c("span", [
                              _c("b", [_vm._v("Park/Play Area Perimeter:")]),
                              _vm._v(
                                " " + _vm._s(item["Park/Play Area Perimeter"])
                              ),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item["Play/Park Access"]
                          ? _c("span", [
                              _c("b", [_vm._v("Park/Play Access:")]),
                              _vm._v(" " + _vm._s(item["Play/Park Access"])),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item["Restroom Access"]
                          ? _c("span", [
                              _c("b", [_vm._v("Restroom Access:")]),
                              _vm._v(" " + _vm._s(item["Restroom Access"])),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item["accessible playground equip."]
                          ? _c("span", [
                              _c("b", [
                                _vm._v("Accessible Playground Equipment:")
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(item["accessible playground equip."])
                              ),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item["Play/Surface Ground Cover"]
                          ? _c("span", [
                              _c("b", [_vm._v("Play Surface Material:")]),
                              _vm._v(
                                " " + _vm._s(item["Play/Surface Ground Cover"])
                              ),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item["Access to Sun Cover"]
                          ? _c("span", [
                              _c("b", [_vm._v("Access to Sun Cover:")]),
                              _vm._v(" " + _vm._s(item["Access to Sun Cover"])),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item["Proximity to Roads"]
                          ? _c("span", [
                              _c("b", [_vm._v("Proximity to Roads:")]),
                              _vm._v(" " + _vm._s(item["Proximity to Roads"])),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item["seating"]
                          ? _c("span", [
                              _c("b", [_vm._v("Seating:")]),
                              _vm._v(" " + _vm._s(item["seating"])),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item["Fresh Water on Site"] &&
                        item["Fresh Water on Site"] != "n/a"
                          ? _c("span", [
                              _c("b", [_vm._v("Pond/Stream:")]),
                              _vm._v(" " + _vm._s(item["Fresh Water on Site"])),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item["Play Area on Site"] &&
                        item["Play Area on Site"] != "N/A"
                          ? _c("span", [
                              _c("b", [_vm._v("Play Area on Site:")]),
                              _vm._v(" " + _vm._s(item["Play Area on Site"])),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item["trails"] && item["trails"] != "N/A"
                          ? _c("span", [
                              _c("b", [_vm._v("Trails:")]),
                              _vm._v(" " + _vm._s(item["trails"])),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.openLink(item["URL"])
                              }
                            }
                          },
                          [_vm._v("View Full Park Details")]
                        )
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d6e8f8ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6e8f8ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parksAccessibility/parksAccessibility.vue
// module id = x3sZ
// module chunks = 1